import * as tslib_1 from "tslib";
import { Component, Watch } from "vue-property-decorator";
import SmartApprove from "../shared/smart-approve/index.vue";
import myComments from "../../../../../flow-center/src/components/pc/my-comments.vue";
import { Icon, Button, Upload, Modal, Select, Checkbox, Tooltip, Input, Popover } from "@h3/antd-vue";
import { ApproveOpinionControl } from "../../controls";
import { workflowCenterApi, externalLinkApi, formApi } from "@cloudpivot/api";
import common from "@cloudpivot/common/pc";
let ApproveOpinion = class ApproveOpinion extends ApproveOpinionControl {
    constructor() {
        super(...arguments);
        this.QRCodeShow = false;
        this.currentRefID = ''; // 存储已经上传了签名的refid，以防再次打开签名二维码刷新覆盖
        this.refId = '';
        this.autographUrl = ''; // 签名地址
        this.qrCodeUrl = '';
        this.uploading = false;
        this.commonCommentSwitch = false;
        this.lastAutographUrl = ''; // 上一次使用的签名
        this.lastAutographRefId = '';
        this.lastAttachment = '';
        // 常用审批意见
        this.popoverVisible = false;
        this.searchText = '';
        this.isCommon = false;
        this.checkedComment = undefined;
        this.myComments = [];
        this.visible = false;
        this.currentComment = '';
        this.currentEdit = '';
        this.delVisible = false;
    }
    removeAutograph() {
        this.val.resources = this.val.resources.filter(el => el.refId !== this.currentRefID && el !== '');
        this.ctrl.value = Object.assign(this.val, {});
        this.fileList = this.fileList.filter(el => el.uid !== this.currentRefID && el !== '');
        this.refId = '';
        this.currentRefID = '';
        this.autographUrl = '';
    }
    onQRCodeShowChange(value) {
        if (value) {
            this.setRefId();
            this.getQrCodeUrl();
        }
    }
    exist() {
        formApi.exist({
            refId: this.refId
        }).then(res => {
            if (res.errcode === 0 && res.data) {
                this.QRCodeShow = false;
                this.currentRefID = this.refId;
                this.getAutographUrl(this.refId);
                this.setAutographToList(this.refId);
            }
            else if (this.QRCodeShow) {
                setTimeout(() => {
                    this.exist();
                }, 500);
            }
        });
    }
    copyLastAutograph() {
        if (!this.lastAutographRefId) {
            return;
        }
        this.getAutographUrl(this.lastAutographRefId);
        this.setAutographToList(this.lastAutographRefId, true);
    }
    setAutographToList(rerId, isCopy = false) {
        if (this.val.resources) {
            // 删除已经使用的签名，使用新的签名
            this.val.resources = this.val.resources.filter(el => el.name !== 'signsture.png');
            if (isCopy) {
                this.val.resources.push(this.lastAttachment);
            }
            else {
                this.val.resources.push({
                    name: "signsture.png",
                    refId: rerId,
                    mimeType: "image/png"
                });
            }
        }
        else {
            if (isCopy) {
                this.val.resources = [
                    this.lastAttachment
                ];
            }
            else {
                this.val.resources = [
                    {
                        name: "signsture.png",
                        refId: rerId,
                        mimeType: "image/png"
                    }
                ];
            }
        }
        this.ctrl.value = Object.assign(this.val, {});
    }
    onFileListChange(list) {
        if (list.some(el => el.uid === this.currentRefID)) {
            this.fileList = this.fileList.filter(el => el.uid !== this.currentRefID && el !== '');
        }
    }
    getAutographUrl(refId) {
        this.autographUrl = this.getDownloadUrlByRefId(refId) || '';
    }
    getQrCodeUrl() {
        this.qrCodeUrl = '';
        let token = localStorage.getItem('token') || '';
        let origin = location.origin;
        let signinUrl = `${origin}/mobile/#/signature?refId=${this.refId}&T=${token}`;
        // window.open(signinUrl)
        externalLinkApi.generateQrcode(signinUrl).then((res) => {
            let bytes = new Uint8Array(res);
            let data = '';
            let len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                data += String.fromCharCode(bytes[i]);
            }
            this.qrCodeUrl = 'data:image/png;base64,' + window.btoa(data);
            this.exist();
        });
    }
    get val() {
        return this.ctrl.value || {};
    }
    handlePreview() { }
    setControl() {
        this.handleValueChange(this.ctrl.value);
    }
    handleValueChange(value) {
        if (this.uploading) {
            this.uploading = false;
            return;
        }
        if (value && value.resources) {
            this.fileList = value.resources.map((x) => this.map(x));
            this.fileList.filter(el => {
                if (el.name === "signsture.png") {
                    this.getAutographUrl(el.response.data.refId);
                }
            });
        }
    }
    showError(msg) {
        this.$message.error(msg);
    }
    beforeUpload(file) {
        return this.checkFile(file, this.showError);
    }
    checkFile(file, showError) {
        if (!this.checkFileType(file.name, showError)) {
            return false;
        }
        if (!this.checkFileSize(file, showError)) {
            return false;
        }
        return true;
    }
    scrollHandle() {
        if (this.popoverVisible) {
            this.popoverVisible = false;
        }
    }
    mounted() {
        let oDiv = document.querySelector('.form-wrap');
        if (oDiv) {
            oDiv.addEventListener('scroll', this.scrollHandle);
        }
    }
    destroyed() {
        let oDiv = document.querySelector('.form-wrap');
        if (oDiv) {
            oDiv.removeEventListener('scroll', this.scrollHandle);
        }
    }
    setRefId() {
        let user = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.refId = user.username + new Date().getTime();
    }
    get attachmentValue() {
        return this.control.controller && this.control.controller.value && this.control.controller.value || '';
    }
    onControlValChange(value) {
        if (value && value.lastAttachment) {
            this.lastAttachment = value.lastAttachment;
            this.lastAutographRefId = this.lastAttachment.refId;
            // 获取上一次签名
            this.lastAutographUrl = this.getDownloadUrlByRefId(this.lastAutographRefId);
        }
    }
    created() {
        this.setRefId();
        try {
            // @ts-ignore
            this.commonCommentSwitch = this.ctrl.options.commonCommentSwitch;
        }
        catch (error) { }
        this.getCommentList();
    }
    checkedCommentChange(CommentText) {
        this.ctrl.value = Object.assign(this.val, {
            content: CommentText
        });
        this.popoverVisible = false;
    }
    getCommentList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workflowCenterApi.getCommonCommentList({});
            if (res.errcode === 0) {
                this.myComments = res.data;
            }
            else { }
        });
    }
    setCommon() {
        if (this.isCommon && this.myComments.length >= 10) {
            this.$message.error('最多只能设置10条常用审批意见！');
            this.isCommon = false;
            return;
        }
        // @ts-ignore
        this.ctrl.isCommon = this.isCommon;
    }
    onChange(info) {
        if (!this.checkFile(info.file)) {
            return;
        }
        this.fileList = info.fileList;
        this.uploading = true;
        const resources = info.fileList
            .filter(f => f.status === "done")
            .map(f => f.response.data);
        this.ctrl.value = Object.assign(this.val, {
            resources
        });
    }
    onInput(val) {
        // this.ctrl.value.content = val;
        this.ctrl.value = Object.assign(this.val, {
            content: val
        });
    }
    // onCheckboxChange(checked: boolean) {
    //   this.ctrl.value.saveCommon = checked;
    // }
    onSelectFocus() {
        super.search("");
    }
    closePop() {
        this.popoverVisible = false;
    }
    closeModal() {
        this.visible = false;
    }
    modalOK() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let testTxt = this.currentComment.trim();
            if (testTxt === '') {
                this.$message.error('审批意见不能为空！');
                return;
            }
            let params = {
                content: this.currentComment,
                sortKey: 0
            };
            if (this.currentEdit) {
                params.id = this.currentEdit.id;
                params.sortKey = this.currentEdit.sortKey;
            }
            else {
                if (this.myComments.length === 10) {
                    this.$message.error('最多设置10条常用审批意见！');
                    return;
                }
            }
            let res = yield workflowCenterApi.saveCommonComment(params);
            if (res.errcode === 0) {
                this.getList();
                this.visible = false;
                // this.popoverVisible = true;
                this.$message.success('新增成功！');
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    editComments(record) {
        this.currentComment = record.content;
        this.currentEdit = record;
        this.visible = true;
    }
    delComments(record) {
        if (this.delVisible)
            return;
        let _this = this;
        this.delVisible = true;
        this.$confirm({
            title: '确定要删除？',
            okText: '确认',
            cancelText: '取消',
            zIndex: 1040,
            onOk: () => {
                this.deleteCommonComment(record.id);
                this.delVisible = false;
                // this.popoverVisible = true;
            },
            onCancel: () => {
                this.delVisible = false;
                this.popoverVisible = true;
            }
        });
    }
    deleteCommonComment(ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workflowCenterApi.deleteCommonComment({
                ids: ids
            });
            const vm = this;
            if (res.errcode === 0) {
                vm.$message.success('删除成功');
                this.getList();
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    onVisibleChange(val) {
        if (!val) {
            this.currentEdit = '';
            this.currentComment = '';
        }
    }
    commentChange() {
        if (this.currentComment.length > 450) {
            this.currentComment = this.currentComment.substr(0, 450);
        }
    }
    getList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workflowCenterApi.getCommonCommentList({});
            if (res.errcode === 0) {
                res.data.forEach((e, index) => {
                    e.orderNumber = index + 1;
                });
                this.myComments = res.data;
            }
            else {
                this.$message.error(res.errmsg);
            }
            //判断当前常用审批意见是否超过十条（历史数据）如果超过删除多余部分
            if (res.data.length > 10) {
                for (let i = 10; i < res.data.length; i++) {
                    this.deleteCommonComment(res.data[i].id);
                }
            }
        });
    }
};
tslib_1.__decorate([
    Watch('QRCodeShow')
], ApproveOpinion.prototype, "onQRCodeShowChange", null);
tslib_1.__decorate([
    Watch('fileList', {
        deep: true
    })
], ApproveOpinion.prototype, "onFileListChange", null);
tslib_1.__decorate([
    Watch('attachmentValue', { deep: true })
], ApproveOpinion.prototype, "onControlValChange", null);
tslib_1.__decorate([
    Watch('visible')
], ApproveOpinion.prototype, "onVisibleChange", null);
ApproveOpinion = tslib_1.__decorate([
    Component({
        name: "approve-opinion",
        components: {
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
            SmartApprove,
            ASelect: Select,
            ASelectOption: Select.Option,
            ACheckbox: Checkbox,
            ATooltip: Tooltip,
            AInput: Input,
            AInputSearch: Input.Search,
            APopover: Popover,
            myComments,
            PageNoData: common.components.PageNoData,
        }
    })
], ApproveOpinion);
export default ApproveOpinion;
